(function (upp) {
    'use strict';

    FreeModuleController.$inject = [ '$scope', '$routeParams', 'freeModuleApiService', 'appi' ]
    function FreeModuleController($scope, $routeParams, freeModuleApiService, appi) {
        var moduleId = $routeParams.moduleId;
        // Setup the navbar options
        appi.ui.changeActualOption({
            moduleKey2Display: 'free-' + moduleId,
            navbarKey: 'free'
        });
        // Show the loader
        appi.ui.showPageLoadingMsg();
        // This allows the template to be customized on a per-module basis
        $scope.moduleId = moduleId;
        // Retrieve the contents
        freeModuleApiService.getContents(moduleId)
        .then(function(content) {
            $scope.content = content;
        })
        // Swallow any error
        .catch(function(e) {
            console.error('Could not retrieve free module ' + moduleId + ' contents due to', e)
        })
        .then(function() {
            appi.ui.hidePageLoadingMsg();
        })
    }

    upp.controller('upp.free.FreeCtrl', FreeModuleController);
})(upp);


// WEBPACK FOOTER //
// ./src/app/modules/free/controllers/free-controller.js